import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import testimonials from '../data/testimonials';

const { FiArrowLeft, FiArrowRight } = FiIcons;

const AUTOPLAY = 7000;

function TestimonialSlider() {
  const [index, setIndex] = useState(0);

  const go = (step) => setIndex((current) => (current + step + testimonials.length) % testimonials.length);

  useEffect(() => {
    const timer = setTimeout(() => go(1), AUTOPLAY);
    return () => clearTimeout(timer);
  }, [index]);

  const current = testimonials[index];

  return (
    <section className="testimonials" id="kind-words">
      <span className="eyebrow">07 / Words we hold close</span>
      <div className="testimonial-stage">
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={index}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -24 }}
            transition={{ duration: 0.55 }}
          >
            <p><em>“</em>{current.quote}<em>”</em></p>
            <footer>{current.names} — {current.place}</footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>
      <div className="testimonial-controls">
        <button className="slider-arrow" type="button" onClick={() => go(-1)} aria-label="Previous testimonial">
          <SafeIcon icon={FiArrowLeft} />
        </button>
        <span className="testimonial-counter">
          {String(index + 1).padStart(2, '0')} / {String(testimonials.length).padStart(2, '0')}
        </span>
        <button className="slider-arrow" type="button" onClick={() => go(1)} aria-label="Next testimonial">
          <SafeIcon icon={FiArrowRight} />
        </button>
      </div>
    </section>
  );
}

export default TestimonialSlider;
